import React from "react";
import { Card as UI5Card, CardHeader } from "@ui5/webcomponents-react";
import { cn } from "../../../lib/cn";

export function Card({
  className,
  header,
  headerText,
  subtitle,
  headerAction,
  children,
  ...props
}) {
  // Create header if headerText is provided
  const cardHeader =
    header ||
    (headerText && (
      <CardHeader
        titleText={headerText}
        subtitleText={subtitle}
        action={headerAction}
      />
    ));

  return (
    <UI5Card
      header={cardHeader}
      className={cn(
        "w-full", // Full width by default
        "rounded-lg", // Ensure proper border-radius
        className
      )}
      {...props}
    >
      <div className="p-6">{children}</div>
    </UI5Card>
  );
}

/**
 * Sub-components for advanced usage
 */
Card.Header = CardHeader;
